"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var SideMenuSubmenu = {
  styles: function styles(theme) {
    return {
      submenu: {
        color: theme.colors.baseContrast070
      },
      mainItem: {
        height: theme.spacing.base * 5,
        fontWeight: 400,
        color: theme.colors.baseContrast070,
        "&:hover": {
          color: theme.colors.baseContrast070,
          background: theme.colors.baseContrast015
        }
      },
      activeMainItem: {
        paddingInlineStart: theme.spacing.base * 3,
        border: "none"
      },
      active: {
        fontWeight: 400,
        background: theme.colors.primary,
        color: theme.colors.themeBase,
        "&:hover": {
          background: theme.colors.primary,
          color: theme.colors.themeBase
        },
        "& svg": {
          fill: theme.colors.themeBase
        }
      },
      subItem: {
        fontSize: 16,
        height: theme.spacing.base * 5,
        "&:hover": {
          color: theme.colors.baseContrast070,
          background: theme.colors.baseContrast015
        }
      },
      subItemPadding: {
        paddingInlineStart: theme.spacing.base * 6.5
      },
      activeSubmenuItem: {
        "&, & a": {
          background: theme.colors.primary,
          color: theme.colors.themeBase,
          "&:hover": {
            background: theme.colors.primary,
            color: theme.colors.themeBase
          }
        }
      }
    };
  }
};
var _default = exports.default = SideMenuSubmenu;